<template>
  <ipub-model title="Reject Reason"
              width="400px"
              :visable="isVisable"
              confirmText="Re-edit"
              @confirm="confirm"
              @cancel="cancel">
    <div class="ipub-p2">
      {{inputData}}
    </div>
  </ipub-model>
</template>

<script>
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false
    },
    inputData: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      content: ''
    }
  },
  methods: {
    confirm () {
      this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>
